import React from "react";

interface Props {
  remainingClicks: number;
}
const BiddingRemianing = ({ remainingClicks }: Props) => {
  return (
    <div className="flex justify-between mt-6 text-sm font-medium ">
      <p>بازدید باقی مانده:</p>
      <p className="text-base text-pkc-primary" id="remaining">
        {remainingClicks.toLocaleString()}
      </p>
    </div>
  );
};

export default BiddingRemianing;
